import { type RouteComponentProps } from "react-router-dom";
import { ProjectLayout } from "@/routes/app/project/[id]/layout";

export function ProjectRouter(props: RouteComponentProps) {
  return <ProjectLayout />;
}
